import React from "react";
import { Loader2, Inbox, AlertTriangle, Lock } from "lucide-react";

export function Loading({ label = "Caricamento…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-[#CBD5E1]" data-testid="state-loading" role="status">
      <Loader2 className="h-8 w-8 animate-spin text-[#2DD4BF]" />
      <p className="mt-3 text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ title, description, action, icon: Icon = Inbox, testid = "state-empty" }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-[#2A3655] bg-[#141B2D] py-14 px-6 text-center" data-testid={testid}>
      <div className="rounded-full bg-[#1C2640] p-4"><Icon className="h-7 w-7 text-[#2DD4BF]" /></div>
      <h3 className="mt-4 font-display text-xl font-semibold text-[#F8FAFC]">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm text-[#CBD5E1]">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-[#EF4444]/40 bg-[#141B2D] py-14 px-6 text-center" data-testid="state-error" role="alert">
      <div className="rounded-full bg-[#EF4444]/15 p-4"><AlertTriangle className="h-7 w-7 text-[#EF4444]" /></div>
      <h3 className="mt-4 font-display text-lg font-semibold text-[#F8FAFC]">Qualcosa è andato storto</h3>
      <p className="mt-2 max-w-md text-sm text-[#CBD5E1]">{message}</p>
      {onRetry && (
        <button onClick={onRetry} data-testid="retry-button" className="mt-5 rounded-lg border border-[#2A3655] px-4 py-2 text-sm text-[#F8FAFC] hover:bg-[#1C2640]">
          Riprova
        </button>
      )}
    </div>
  );
}

export function AccessDenied({ message = "Devi accedere per usare questa sezione." }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-[#2A3655] bg-[#141B2D] py-14 px-6 text-center" data-testid="state-access-denied">
      <div className="rounded-full bg-[#1C2640] p-4"><Lock className="h-7 w-7 text-[#F59E0B]" /></div>
      <h3 className="mt-4 font-display text-lg font-semibold text-[#F8FAFC]">Accesso riservato</h3>
      <p className="mt-2 max-w-md text-sm text-[#CBD5E1]">{message}</p>
    </div>
  );
}
